__turbopack_context__.v({
  "badge": "notifications-menu-trigger-module-scss-module__lNjpiq__badge",
  "bell_flash": "notifications-menu-trigger-module-scss-module__lNjpiq__bell_flash",
  "bell_shake": "notifications-menu-trigger-module-scss-module__lNjpiq__bell_shake",
  "icon": "notifications-menu-trigger-module-scss-module__lNjpiq__icon",
  "icon_wrap": "notifications-menu-trigger-module-scss-module__lNjpiq__icon_wrap",
  "root": "notifications-menu-trigger-module-scss-module__lNjpiq__root",
  "wrapper": "notifications-menu-trigger-module-scss-module__lNjpiq__wrapper",
});
